ENV = require "config/env"
WP = require "scripts/wordpress"
module.exports =
	back: -> history.back()
	textDecode: (text)-> return text.replace(/\\n/g,"<br>")
	getSimpleBreadObjects: (pageName) ->
		return [
			{ label: "TOP", to: {name: "top"} }
			{ label: pageName, to: null }
		]
	judgeIsEnglish: (route) -> return route.fullPath.match(/en/)
	getProjectNo: (projectName) ->
		switch projectName
			when "project01" then return 1
			when "project02" then return 2
			when "project03" then return 3
			when "supervision" then return 4


// WEBPACK FOOTER //
// ./src/scripts/common.coffee